import { useEffect, useContext } from "react";
import { useSolicitudesCurso } from "../solicitudes-en-curso/useSolicitudesCurso";
import { customStyles, paginationComponentOptions } from "../../utils/Constants";
import { DataContextContractual } from "../../contextData/contextData";
import { ModalBodylHistorial } from "./modalHistorial/modalHistorial";
import { useHistorialSolicitudes } from "./useHistorialSolicitudes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../components/formComponents/Button";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { ModalContractuales } from "../modalForm/modalForm";
import DataTable from "react-data-table-component";
import { UseSolicitudesHistoriales } from "../listado-historial/UseSolicitudesHistoriales";

export const HistorialSolicitudes = () => {
  const { descargarHistorialExcel, descargarHistorialDetalleExcel } = useHistorialSolicitudes();
  const { visible, hideModal, idSolicitud, arrColumnas } = useSolicitudesCurso();
  const { historialListado, traerListadoHistorial } = UseSolicitudesHistoriales();
  const { dataListado } = useContext(DataContextContractual);

  useEffect(() => {
    traerListadoHistorial();
  }, []);

  return (
    <>
      <ModalContractuales
        tamanio="xl"
        show={visible}
        data={{
          titulo: "Historial de solicitud",
          component: <ModalBodylHistorial id={idSolicitud} />,
        }}
        hideModal={hideModal}
      />
      <div className="d-flex align-items-center flex-column">
        <div className="col col-12 col-lg-10 px-4">
          <DataTable
            data={historialListado}
            columns={arrColumnas}
            customStyles={customStyles}
            dense
            pagination
            noDataComponent="No se encontraron registros"
            paginationComponentOptions={paginationComponentOptions}
          />
          {historialListado.length > 0 && (
            <div className="mt-1 d-flex gap-2">
              <Button
                label={
                  <div>
                    Descargar historial
                    <FontAwesomeIcon size="lg" className="ps-3" icon={faDownload} />
                  </div>
                }
                clases="btnCopec ms-0 px-4 cursor-pointer"
                ejecutar={descargarHistorialExcel}
              />
              <Button
                label={
                  <div>
                    Descargar detalle historial
                    <FontAwesomeIcon size="lg" className="ps-3" icon={faDownload} />
                  </div>
                }
                clases="btnCopec bg-success ms-0 px-4 cursor-pointer"
                ejecutar={descargarHistorialDetalleExcel}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
